import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root"
})
export class LoadedContextService {
  public origUrl: string;

  constructor() {
    this.origUrl = window.location.href;
  }

  isComposeMode() {
    // action url are defined in https://superofficeforoutlook-sod.superoffice.com/manifest/manifest.xml
    return this.origUrl.indexOf("compose") !== -1;
  }

  isComposeAppointment() {
    return this.origUrl.indexOf("compose/compose-appointment") !== -1;
  }

  isReadAppointment() {
    return this.origUrl.indexOf("/appointment") !== -1;
  }

  isCalendar() {
    return this.isComposeAppointment() || this.isReadAppointment();
  }
}
